// import cx from 'classnames';
import { useState } from 'react';

function useActions() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openFontsModal, setOpenFontsModal] = useState(false);
  const [drawerType, setDrawerType] = useState(null);
  const handleOpenCuctomCss = () => {
    setOpenDrawer(true);
    setDrawerType('css');
  };
  const handleOpenFontsModal = () => setOpenFontsModal(true);
  const handleCloseDrawer = () => setOpenDrawer(false);
  const handleCloseFontsModal = () => setOpenFontsModal(false);

  return {
    handleOpenCuctomCss,
    handleOpenFontsModal,
    openDrawer,
    handleCloseDrawer,
    drawerType,
    handleCloseFontsModal,
    openFontsModal,
  };
}

export default useActions;
